import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { categories, comics } from '@/mocks/comics';

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const [activeCategory, setActiveCategory] = useState(slug || 'danmei');
  const [filteredComics, setFilteredComics] = useState(comics);

  useEffect(() => {
    if (slug) {
      setActiveCategory(slug);
    }
  }, [slug]);

  useEffect(() => {
    setFilteredComics(comics.filter((c) => c.category === activeCategory));
  }, [activeCategory]);

  const currentCategory = categories.find((c) => c.slug === activeCategory);

  return (
    <div className="min-h-screen pt-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-6">
        {/* Breadcrumb */}
        <nav className="flex items-center gap-2 text-xs text-foreground-500 mb-6" aria-label="面包屑导航">
          <Link to="/" className="hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">首页</Link>
          <i className="ri-arrow-right-s-line"></i>
          <span className="text-foreground-800 whitespace-nowrap">分类浏览</span>
          {currentCategory && (
            <>
              <i className="ri-arrow-right-s-line"></i>
              <span className="text-primary-500 font-medium whitespace-nowrap">{currentCategory.name}</span>
            </>
          )}
        </nav>

        {/* Category Tabs */}
        <div className="flex items-center gap-2 flex-wrap mb-8">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className={`px-4 py-1.5 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                activeCategory === cat.slug
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200'
              }`}
            >
              {cat.name}
            </Link>
          ))}
        </div>

        {/* Category Header */}
        {currentCategory && (
          <div className="mb-8">
            <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
              {currentCategory.name}漫画
            </h1>
            <p className="text-sm text-foreground-500">{currentCategory.description}</p>
          </div>
        )}

        {/* Comics Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5">
          {filteredComics.map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="group cursor-pointer"
            >
              <div className="relative aspect-[3/4] rounded-lg overflow-hidden bg-background-100 mb-2">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute top-2 left-2 px-1.5 py-0.5 rounded text-[10px] font-medium bg-primary-500 text-background-50">
                  {comic.rating}
                </div>
                {comic.status === '连载中' && (
                  <div className="absolute bottom-0 left-0 right-0 py-1 bg-accent-500/90 text-center text-[10px] font-medium text-background-50">
                    连载中
                  </div>
                )}
                {comic.status === '已完结' && (
                  <div className="absolute bottom-0 left-0 right-0 py-1 bg-foreground-700/80 text-center text-[10px] font-medium text-background-50">
                    已完结
                  </div>
                )}
              </div>
              <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 line-clamp-1">
                {comic.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-0.5">{comic.author}</p>
            </Link>
          ))}
        </div>

        {filteredComics.length === 0 && (
          <div className="text-center py-20">
            <i className="ri-inbox-line text-4xl text-foreground-300 mb-3 block"></i>
            <p className="text-foreground-500">该分类暂无漫画</p>
          </div>
        )}
      </div>
    </div>
  );
}

export function CategorySEO() {
  return null;
}